import {
	FETCH_ANSWER_RULES_REQUEST,
	FETCH_ANSWER_RULES_SUCCESS,
	FETCH_ANSWER_RULES_FAIL,
	UPDATE_ANSWER_RULE_REQUEST,
	UPDATE_ANSWER_RULE_SUCCESS,
	UPDATE_ANSWER_RULE_FAIL,
	FETCH_ANSWER_RULE_REQUEST,
	FETCH_ANSWER_RULE_SUCCESS,
	FETCH_ANSWER_RULE_FAIL,
} from "../constants/answerRule";

function fetchAnswerRulesReducer(state, action) {
	if (typeof state === "undefined") {
		state = {
			status: "IDLE",
			answerRules: {},
			error: null,
			answerRuleUpdated: false,
		};
	}
	switch (action.type) {
		case FETCH_ANSWER_RULES_REQUEST:
			return { loading: true, status: "IDLE" };
		case FETCH_ANSWER_RULES_SUCCESS:
			return {
				loading: false,
				status: "SUCCEEDED",
				answerRules: action.payload,
			};
		case FETCH_ANSWER_RULES_FAIL:
			return { loading: false, status: "FAILED", error: action.payload };
		default:
			return state;
	}
}

function updateAnswerRuleReducer(state, action) {
	if (typeof state === "undefined") {
		state = {};
	}
	switch (action.type) {
		case UPDATE_ANSWER_RULE_REQUEST:
			return { loading: true };
		case UPDATE_ANSWER_RULE_SUCCESS:
			return {
				loading: false,
				status: "SUCCEEDED",
				answerRuleUpdated: true,
			};
		case UPDATE_ANSWER_RULE_FAIL:
			return { loading: false, status: "FAILED" };
		default:
			return state;
	}
}

function fetchAnswerRuleReducer(state, action) {
	if (typeof state === "undefined") {
		state = {
			status: "IDLE",
			answerRule: {},
			error: null,
			answerRuleUpdated: false,
		};
	}
	switch (action.type) {
		case FETCH_ANSWER_RULE_REQUEST:
			return { loading: true, status: "IDLE" };
		case FETCH_ANSWER_RULE_SUCCESS:
			return {
				...state,
				loading: false,
				status: "SUCCEEDED",
				answerRule: action.payload,
			};
		case FETCH_ANSWER_RULE_FAIL:
			return { loading: false, status: "FAILED" };
		default:
			return state;
	}
}

export {
	fetchAnswerRulesReducer,
	updateAnswerRuleReducer,
	fetchAnswerRuleReducer,
};
